module.exports = __webpack_public_path__ + "img/tumbler-glass.c9d14643.png";